import { OrderedList } from 'prosemirror/schema-basic';

function configureToDom(listClass, style) {
  listClass.prototype.toDOM = (node) => [
    'ol',
    {
      start: node.attrs.order !== '1' && node.attrs.order,
      style: `list-style-type: ${style};`,
    },
    0,
  ];
}

export class LowerRomanList extends OrderedList {}
configureToDom(LowerRomanList, 'lower-roman');

export class UpperRomanList extends OrderedList {}
configureToDom(UpperRomanList, 'upper-roman');

export class LowerAlphaList extends OrderedList {}
configureToDom(LowerAlphaList, 'lower-alpha');

export class UpperAlphaList extends OrderedList {}
configureToDom(UpperAlphaList, 'upper-alpha');
